import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const AptevoInventoryEdit = (props) => {
	let fileName = "Aptevo Inventory Source";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));

	const AptevoInventory = JSON.parse(localStorage.getItem("AptevoInventory"));
	const userData = localStorage.getItem("userData");
	const history = useHistory();
	// const [sales, setSales] = useState([]);
	// const [gridSales, setGridSales] = useState([]);
	const [gridData, setGridData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	// const [gridShow, setGridShow] = useState(false);
	// const [cont, setCont] = useState({});
	const [chargeback, setChargeBack] = useState({});
	const [inventory, setInventory] = useState({});
	const [indicator, setIndicator] = useState(false);
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const initialvalues = {
		AvailableQuantity: "",
		DistributorName: "",
		ExpirationDate: "",
		FileProcessID: "",
		LotNumber: "",
		NDC: "",
		ProductName: "",
		QP: "",
		QR: "",
		QS: "",
		ReportingDate: "",
		TotalUnit: "",
		UnitsOrVial: "",
	};
	// const [newChargeBack, setNewChargeBack] = useState(initialvalues);
	const [newInventory, setNewInventory] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	//
	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			accessor: "accessor",

			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					<Button
						variant="link"
						onClick={() => deleteRecord(row)}
						className="grid-action-btn ml-2"
						title="Delete Row"
					>
						<IoMdTrash className="icon fa-icon" />
					</Button>
					{/* <Button variant="link" onClick={() => copyReport(row.row.original)} className="grid-action-btn ml-2" title="Disable Task">
                        <IoMdCreate className="icon" />
                    </Button> */}
				</Fragment>
			),
		},
		{
			Header: "PRODUCT",
			accessor: "ProductName",
			filter: "ProductName",
			sortType: "basic",
			width: 200,
			key: true,
		},
		{
			Header: "NDC",
			accessor: "NDC",
			filter: "NDC",
			sortType: "basic",
			width: 130,
			key: true,
		},
		{
			Header: "LOT",
			accessor: "LotNumber",
			filter: "LotNumber",
			sortType: "basic",
			width: 90,
			key: true,
		},

		{
			Header: "LOT Exp",
			accessor: "ExpirationDate",
			filter: "ExpirationDate",
			sortType: "basic",
			width: 110,
			key: true,
			field: true,
		},
		{
			Header: "#Vials purchased",
			accessor: "QP",
			filter: "QP",
			sortType: "basic",
			width: 140,
			key: true,
		},
		{
			Header: "Remaining vials",
			accessor: "AvailableQuantity",
			filter: "AvailableQuantity",
			sortType: "basic",
			width: 135,
			key: true,
		},
		{
			Header: "TOTAL UNITS",
			accessor: "TotalUnit",
			filter: "TotalUnit",
			sortType: "basic",
			width: 120,
			key: true,
		},
		{
			Header: "Units/Vial",
			accessor: "UnitsOrVial",
			filter: "UnitsOrVial",
			sortType: "basic",
			width: 105,
			key: true,
		},
		{
			Header: "LOCATION",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
			key: true,
		},
		{
			Header: "Purchase Date",
			accessor: "ReportingDate",
			filter: "ReportingDate",
			sortType: "basic",
			width: 116,
			key: true,
			field: true,
			future: true,
		},
	];

	//

	//
	useEffect(() => {
		// getAdvanceShipNotice();
		setGridData(AptevoInventory);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		console.log(e);
		if (
			name === "NDC" ||
			name === "LotNumber" ||
			name === "QP" ||
			name === "AvailableQuantity" ||
			name === "TotalUnit" ||
			name === "UnitsOrVial"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setInventory((values) => ({
					...values,
					[name]: value,
				}));
			}
		} else {
			setInventory((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};
	const newhandleChange = (e) => {
		const { name, value } = e.target;
		console.log(e);
		if (
			name === "NDC" ||
			name === "LotNumber" ||
			name === "QP" ||
			name === "AvailableQuantity" ||
			name === "TotalUnit" ||
			name === "UnitsOrVial"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewInventory((values) => ({
					...values,
					[name]: value,
				}));
			}
		} else {
			setNewInventory((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};
	function copyReport(row) {
		// delete gridSales[row.row.index];
		let obj = Object.assign({}, row);
		obj.ind = gridData.length + 1;
		const row1 = Object.assign({}, obj);
		gridData.push(row1);
		const deletedData = Object.assign([], gridData);
		setGridData(deletedData);
	}
	function deleteRecord(row) {
		console.log(row.row.original);

		// delete gridData[row.row.index];
		let data = gridData.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridData(deletedData);
	}
	const handleChangeDate = (date, i) => {
		const re = i;
		setInventory((values) => ({
			...values,
			ReportingDate: date,
		}));
	};

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newInventory]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [inventory]);

	const validateEditForm = () => {
		if (
			inventory.ProductName &&
			inventory.ProductName.toString().trim() !== "" &&
			inventory.NDC &&
			inventory.NDC.toString().trim() !== "" &&
			inventory.LotNumber &&
			inventory.LotNumber.toString().trim() !== "" &&
			(inventory.QP || inventory.QP === 0) &&
			inventory.QP.toString().trim() !== "" &&
			(inventory.AvailableQuantity || inventory.AvailableQuantity === 0) &&
			inventory.AvailableQuantity.toString().trim() !== "" &&
			inventory.TotalUnit &&
			inventory.TotalUnit.toString().trim() !== "" &&
			inventory.UnitsOrVial &&
			inventory.UnitsOrVial.toString().trim() !== "" &&
			inventory.DistributorName &&
			inventory.DistributorName.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};
	const validateForm = () => {
		if (
			newInventory.ProductName &&
			newInventory.ProductName.toString().trim() !== "" &&
			newInventory.NDC &&
			newInventory.NDC.toString().trim() !== "" &&
			newInventory.LotNumber &&
			newInventory.LotNumber.toString().trim() !== "" &&
			(newInventory.QP || newInventory.QP === 0) &&
			newInventory.QP.toString().trim() !== "" &&
			(newInventory.AvailableQuantity ||
				newInventory.AvailableQuantity === 0) &&
			newInventory.AvailableQuantity.toString().trim() !== "" &&
			newInventory.TotalUnit &&
			newInventory.TotalUnit.toString().trim() !== "" &&
			newInventory.UnitsOrVial &&
			newInventory.UnitsOrVial.toString().trim() !== "" &&
			newInventory.DistributorName &&
			newInventory.DistributorName.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};
	function saveRowHandler() {
		newInventory.ExpirationDate = moment(
			newInventory.ExpirationDate ? newInventory.ExpirationDate : new Date()
		).format("MM/DD/YYYY");
		newInventory.ReportingDate = moment(
			newInventory.ReportingDate ? newInventory.ReportingDate : new Date()
		).format("MM/DD/YYYY");
		const ns = Object.assign({}, newInventory);
		gridData.unshift(ns);
		setaddShowConfirm(false);
		setNewInventory(initialvalues);
	}
	function editRowHandler() {
		let indicator = 0;

		// chargeback.ReportDate = moment(chargeback.ReportDate).format('MM/DD/YYYY');
		inventory.ExpirationDate = moment(
			inventory.ExpirationDate ? inventory.ExpirationDate : new Date()
		).format("MM/DD/YYYY");
		inventory.ReportingDate = moment(
			inventory.ReportingDate ? inventory.ReportingDate : new Date()
		).format("MM/DD/YYYY");
		// inventory.CustomersInvoiceDate = moment(inventory.CustomersInvoiceDate).format('MM/DD/YYYY');
		// if (chargeback.CustID && chargeback.CustID) {

		// gridSales[cont.ind-1] =cont;
		if (editOrSaveInd) {
			gridData.filter((element, index) => {
				if (editIndex === index) {
					const cbk = Object.assign({}, inventory);
					gridData[index] = cbk;
				}
			});
		}

		indicator = 1;
		// }

		if (indicator != 0) {
			console.log(inventory);
			setShowConfirm(false);
			setIndicator(false);
		} else {
			setIndicator(true);
		}
	}
	const editReport = (inventory) => {
		// setDeleteTask(task)
		setEditIndex(inventory.row.index);
		setInventory(inventory.row.original);
		setShowConfirm(true);
		setEditOrSaveInd(true);
	};

	const EditRecords = () => {
		// setShowConfirm(true);
		// setGridShow(true);
	};
	const saveRecords = () => {
		//    setCont({})
		// setShowConfirm(true);
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		gridData.map((element) => {
			element.FileProcessID = AptevoInventory[0].FileProcessID;
			element.ModifiedOn = new Date();
			element.LastModifiedBy = JSON.parse(userData).UserName;
			element.IsResendRequired =
				outbounddata.FileSentStatus == "Sent" ? true : false;
			element.IsReadyforReversal = true;
			element.IsEdited = true;
			element.Version = 1;
			element.Service_Task_Id = outbounddata.ServiceTaskID;
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/Reversal852ExcelOutbound", gridData)
			.then((data) => {
				if (data.data === "") {
					setLoading(false);
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 1000);
				}
			})
			.catch((e) => {
				setLoading(false);
			});
	};
	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					<Button variant="primary" type="button" onClick={() => saveRecords()}>
						Add Record
					</Button>
					{/* <Button type="submit" onClick={() =>EditRecords()}>EditRecords</Button> */}

					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridData, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
				{/* insert */}

				<Modal
					show={addshowConfirm}
					onHide={() => setaddShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Add Record
						</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i) {
													return (
														i.accessor != "accessor" && (
															<Col md={3}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label
																			htmlFor="StartDate"
																			title={i.Header}
																		>
																			{/* Since */}
																			{i.accessor != "accessor" ? i.Header : ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={newInventory[i.accessor]}
																				selected={
																					newInventory[i.accessor]
																						? new Date(
																								moment(
																									newInventory[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setNewInventory((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={i.future ? new Date() : null}
																			/>
																		)}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={newInventory[i.accessor]}
																				key={inventory[i.accessor]}
																				onChange={(e) => newhandleChange(e)}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>

						{/*  */}
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								type="submit"
								disabled={disableSubmit}
								onClick={() => saveRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Save
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setaddShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
				{/* insert end */}
				{/* Modal */}
				<Modal
					show={showCOnfirm}
					onHide={() => setShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Edit Record
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i) {
													return (
														i.accessor != "accessor" && (
															<Col md={3}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{/* Since */}
																			{i.accessor != "accessor" ? i.Header : ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={inventory[i.accessor]}
																				// selected = {i.field)}
																				selected={
																					i.field
																						? new Date(
																								moment(
																									inventory[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setInventory((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={i.future ? new Date() : null}
																			/>
																		)}
																		{/* {i.Header.indexOf('Date') == -1  && <Form.Control */}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={inventory[i.accessor]}
																				// key={cont[i.accessor]}
																				onChange={(e) => handleChange(e)}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								disabled={addDisableSubmit}
								onClick={() => editRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Edit Row
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			<Row>
				<Col md={12}>
					{/* <Row> */}
					<span className="mb-4 h6">
						File Name: {outbounddata.File_Process_Name}
					</span>{" "}
					<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
					{/* </Row> */}
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load {fileName}</p>
								) : (
									<Fragment>
										{gridData.length > 0 ? (
											<ReactTable
												columns={Gridcolumns}
												data={gridData}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			{/*end  */}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridData.length > 0 && (
						<Button
							variant="primary"
							type="button"
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};
export default AptevoInventoryEdit;
